import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {ManufacturingItemModel} from "web-shared";
import {ManufacturingItemService} from "./manufacturing-item.service";
import {truncate} from "lodash-es";

@Injectable({
  providedIn: 'root'
})
export class ManufacturingItemResolver  {
  constructor(private manufacturingItemService: ManufacturingItemService) {
  }
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<ManufacturingItemModel> | Promise<ManufacturingItemModel> | ManufacturingItemModel {
    return this.manufacturingItemService.loadOne(route.params.id).pipe(map(value => {
      route.routeConfig.data ??= {};
      route.routeConfig.data['breadcrumb'] = truncate(value.DisplayName, {length: 100});
      route.routeConfig.data['entity'] = value;
      route.routeConfig.data['search'] = {
        enabled: false
      };
      return value;
    }));
  }
}
